<div class="input-container" [class]="getClassList()">
    <input #inputField aria-label="Search text" (focus)="onFocus(true)" (blur)="onFocus(false)" [(ngModel)]="value"
        (ngModelChange)="onModelChange($event)" (keydown.enter)="onSearch()" placeholder="{{hint()}}"/>
    <img class="input-container__search-icon" alt="Search" src="assets/icons/common/search.svg">
    <div class="input-container__input-indicator"></div>
    <div class="input-container__error-message">{{errorMessage()}}</div>
</div>
